// export const API_BASE_URL = 'http://192.168.1.12:1996/api/v1/'
// export const API_BASE_URL = 'https://ajiji-api.iosx.in/api/v1/'
export const API_BASE_URL = 'https://simplificaapi.iosx.in/api/v1/'